var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"fieldone",style:({ flexGrow: _vm.field1Grow })},[_vm._v(_vm._s(_vm.field1Content))]),_c('div',{staticClass:"fieldtwo",style:({ flexGrow: _vm.field2Grow })},[_vm._v(_vm._s(_vm.field2Content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }